import React from 'react';
import { TIMELINE_NOTE_TEXT_CLASS } from '@/components/config_forms/shared/help-graphics/timeline/timelineTextTokens';

interface OTScaledNoteProps {
  visible: boolean;
}

/** Animated reveal callout explaining that the hourly premium scales by the OT multiplier. */
export const OTScaledNote: React.FC<OTScaledNoteProps> = ({ visible }) => (
  <div
    className="grid motion-safe:transition-[grid-template-rows,margin-top] motion-safe:duration-[250ms] motion-safe:ease-[cubic-bezier(0.4,0,0.2,1)]"
    style={{
      gridTemplateRows: visible ? '1fr' : '0fr',
      marginTop: visible ? 12 : 0,
    }}
  >
    <div className="overflow-hidden min-h-0">
      <div
        className={`px-2 py-2 rounded-[0.25rem] border ${TIMELINE_NOTE_TEXT_CLASS} text-foreground/90`}
        style={{
          borderColor: 'color-mix(in srgb, var(--primary-text), transparent 88%)',
          backgroundColor: 'color-mix(in srgb, var(--primary-text), transparent 96%)',
        }}
      >
        <strong className="font-medium" style={{ color: 'color-mix(in srgb, var(--primary-text), transparent 10%)' }}>
          Scaled:
        </strong>{' '}
        The hourly premium scales by the active overtime multiplier.
      </div>
    </div>
  </div>
);
